// jscs:disable requireCamelCaseOrUpperCaseIdentifiers

define('disable-click',['require','knockout'],function (require) {
    var ko = require('knockout');

    ko.bindingHandlers.disableClick = {
        init: function (element, valueAccessor) {
            $(element).click(function (evt) {
                if (valueAccessor()) {
                    evt.preventDefault();
                }
            });
        },

        update: function (element, valueAccessor) {
            var value = ko.utils.unwrapObservable(valueAccessor());
            ko.bindingHandlers.css.update(element, function () {
                return {disabled_anchor: value};
            });
        }
    };

    ko.applyBindings({enabled: ko.observable(false)});
});

